import { createContext } from 'react'

/**
 * What the dealer switcher in the page header needs from above (WARP-920): the dealers
 * this user can pick, and how to move to one. Provided by Routes, which owns both the
 * dealer list and the nav's areas, so the header does not fetch or route on its own.
 *
 * `onSwitch(dealerId)` takes null for "All dealers", offered only when `canShowAll`.
 * It is null outside a provider; the header then shows a plain heading.
 *
 * `marksRoIntake` tags the dealers with RO Intake. In an RO Intake area those open the
 * area's page; the rest open their Outstanding List instead.
 */
export const DealerSwitcherContext = createContext({
  canShowAll: false,
  marksRoIntake: false,
  dealerOptions: [],
  onSwitch: null,
})
